import script from "./AutoComplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoComplete.vue?vue&type=script&setup=true&lang=ts"

import "./AutoComplete.vue?vue&type=style&index=0&id=5ca5d6a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ca5d6a3"]])

export default __exports__